<template>
  <v-app class="bg-aqua-teal d-flex align-center justify-center" style="height: 100vh;">
    <v-container style="margin-top: 25vh;">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-progress-linear :active="loading" :indeterminate="loading" color="#FF6D44"/>
          <v-card outlined class="pa-5">
            <v-card-title class="text-center text-h5 font-weight-bold text-aqua-teal">
              {{ (transition === 0) ? "Forgot Password" :"Reset Email Sent" }}
            </v-card-title>
            <v-card-text v-if="!transition">
              <v-form ref="forgotForm" v-model="isFormValid">
                <v-text-field v-model="email" label="Email Address" type="email" outlined dense
                  :rules="[rules.required, rules.email]"></v-text-field>
              </v-form>
              <div class="d-flex justify-center mt-4">
                <v-btn class="bg-bright-orange text-pure-white" :disabled="!isFormValid || loading" @click="sendResetLink">
                  Send Reset Link
                </v-btn>
              </div>
            </v-card-text>
            <v-card-text v-else class="text-start text-charcoal-blue">
              An email has been sent to <span class="text-aqua-teal">{{ email }}</span>, if it is associated with an account.
              This email contains a link to reset your password.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      isFormValid: false,
      rules: {
        required: (value) => !!value || "This field is required",
        email: (value) =>
          /.+@.+\..+/.test(value) || "Enter a valid email address",
      },
      transition: 0,
      loading: false,
    };
  },
  methods: {
    async sendResetLink() {
      this.loading = true;
      if (this.$refs.forgotForm.validate()) {
        try{
          // Call API to send reset link (replace with actual backend call)
          await axios.post("/api/auth/forgot-password", { "Email": this.email })
          .then(() => {
            this.transition = 1;
            this.loading = false;
          });
        } catch (error){
          console.log(error.response);
          ""; 
        }
        this.transition = 1; 
      }
      this.loading = false; 
    },
  },
};
</script>

<style>
.text-aqua-teal {
  color: #08B6AA;
}

.text-pure-black {
  color: #000000;
}

.text-pure-white {
  color: #FFFFFF;
}

.text-charcoal-blue {
  color: #293840;
}

.bg-aqua-teal {
  background-color: #08B6AA;
}

.bg-bright-orange {
  background-color: #FF6D44;
}

</style>